import { h, FunctionComponent } from 'preact';
import { useDispatch, useSelector } from 'react-redux';
import { DocumentIcon } from '~src/domains/common/assets/svg';
import LinkWrapper from '~src/domains/common/components/LinkWrapper';
import { Brand } from '~src/domains/common/enums/common';
import { Doc } from '~src/domains/common/enums/docs';
import { Language } from '~src/domains/common/enums/localization';
import { brandSelector } from '~src/domains/common/state/commonSelectors';
import * as styles from '~src/styles/domains/loanConsent/LoanConsentPage.module.scss';
import { translateBigDocument } from '~src/utils/documents/documents';

type DocumentJumpLinkProps = {
  name: string;
  docId: Doc;
  language: Language;
  isActive: boolean;
};

/**
 * Link component that jumps to document position on page
 *
 * @param name: name displayed
 * @param docId: id that links to document
 * @param language: language
 * @param isActive: boolean for first doc
 *
 */
const DocumentJumpLink: FunctionComponent<DocumentJumpLinkProps> = ({
  name,
  docId,
  language,
  isActive,
}) => {
  const dispatch = useDispatch();
  const brand = useSelector(brandSelector);
  const isUplift = brand == Brand.UPLIFT;

  const onClickHandler = () => {
    dispatch(translateBigDocument(docId, language));
  };

  return (
    <div className={styles['agreement-item']}>
      <DocumentIcon size={20} color={isUplift ? '#383D47' : '#0e680e'} />
      <LinkWrapper
        id={`jumplink-${docId}`}
        classLabel={`jump-link ${isActive ? 'active' : ''}`}
        trackingConfig={{
          label: 'document',
          payload: { label: docId },
        }}
        onClickHandler={onClickHandler}
      >
        {name}
      </LinkWrapper>
    </div>
  );
};

export default DocumentJumpLink;
